import React, { useContext } from 'react'

import { PayPalMessages, SCRIPT_LOADING_STATE, ScriptContext } from '@paypal/react-paypal-js'
import { PayPalMessagesComponentProps } from '@paypal/react-paypal-js/dist/types/components/PayPalMessages'
import { Box, Text } from '@vividseats/vivid-ui-kit'

import braintreeContext from '@/context/braintree'

import styles from './styles.module.scss'

const PaypalMessagesWrapper: React.FC<PayPalMessagesComponentProps & { shouldShowInsuranceText?: boolean }> = ({
    shouldShowInsuranceText,
    ...paypalMessagesProps
}) => {
    const {
        selector: { btGatewayConfigSelector, clientToken },
    } = useContext(braintreeContext)

    const paypalScriptContext = useContext(ScriptContext)
    const paypalClientId = btGatewayConfigSelector?.paypal?.clientId || ''

    return (
        <Box
            className={styles.messagesContainer}
            data-testid={`paypal-messages-wrapper-container${shouldShowInsuranceText ? '-with-insurance' : ''}`}
        >
            {clientToken && paypalClientId && paypalScriptContext?.loadingStatus === SCRIPT_LOADING_STATE.RESOLVED && (
                <div className={styles.paypalBox}>
                    <PayPalMessages
                        placement="payment"
                        currency="USD"
                        forceReRender={[paypalMessagesProps]}
                        {...paypalMessagesProps}
                        className={styles.paypalMessage}
                    />
                    {shouldShowInsuranceText && (
                        <Text size="sm" as="span" weight="regular" className={styles.insuranceMessage}>
                            This Excludes Insurance.
                        </Text>
                    )}
                </div>
            )}
        </Box>
    )
}

export default PaypalMessagesWrapper
